import { render } from "./WhyChoose.vue?vue&type=template&id=56871a4a"
import script from "./WhyChoose.vue?vue&type=script&lang=js"
export * from "./WhyChoose.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__